import React from "react";
import DraggablePanel from "./DraggablePanel";
import FieldLabel from "../ui/FieldLabel";
import MutedText from "../ui/MutedText";

const XmlSourceOfTruthPanel = ({
  open,
  onClose,
  titleIcon,
  groups = [],
  loadingEntryId = "",
  selectedEntryId = "",
  onSelectEntry,
  mobilePinPanelId,
}) => {
  return (
    <DraggablePanel
      open={open}
      onClose={onClose}
      title="XML Source of Truth"
      titleIcon={titleIcon}
      initialSize={{ width: 420, height: 520 }}
      minWidth={360}
      minHeight={360}
      mobilePinPanelId={mobilePinPanelId}
    >
      <div className="flex flex-col h-full p-3">
        <FieldLabel className="mb-3 select-none">
          Load a scene directly from an XML asset for sanity-checking.
        </FieldLabel>
        <div className="flex-1 overflow-y-auto space-y-4 pr-1">
          {groups.map((group) => (
            <div key={group.id} className="space-y-1.5">
              <div className="text-xs font-medium uppercase tracking-wide text-gray-400 px-1">
                {group.label}
              </div>
              {(group.entries || []).map((entry) => {
                const isSelected = selectedEntryId === entry.key;
                const isLoading = loadingEntryId === entry.key;
                return (
                  <button
                    key={entry.key}
                    type="button"
                    disabled={Boolean(loadingEntryId)}
                    className={`w-full text-left px-3 py-2 rounded-md border transition-colors ${
                      isSelected
                        ? "border-green-600 bg-green-900/20 text-green-300"
                        : "border-gray-700 bg-transparent text-gray-200 hover:border-gray-600"
                    } ${loadingEntryId ? "opacity-60 cursor-not-allowed" : ""}`}
                    onClick={() => {
                      if (!loadingEntryId) onSelectEntry?.(entry);
                    }}
                  >
                    <span className="flex items-center justify-between gap-3">
                      <span className="min-w-0">
                        <span className="block truncate">{entry.name}</span>
                        <span className="block text-xs text-gray-400 truncate">
                          {entry.xmlFilename}
                        </span>
                      </span>
                      {isLoading && (
                        <span className="w-3.5 h-3.5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin shrink-0" />
                      )}
                    </span>
                  </button>
                );
              })}
            </div>
          ))}
          {groups.every((group) => (group.entries || []).length === 0) && (
            <MutedText className="italic px-1 py-2">No XML-backed assets available.</MutedText>
          )}
        </div>
      </div>
    </DraggablePanel>
  );
};

export default XmlSourceOfTruthPanel;
